import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import ConnectContext from '../../context/connectContext';
import ChatUserAvatar from '../../ChatList/ChatRoomItem/ChatUserAvatar';
import { displayDate } from '../../helpers/index';
import formatLastMessage from '../../helpers/message';
import '../../context/global';

import './chatconnectroomitem.scss';

const ChatConnectRoomItem = ({ ...props }) => {
  const [title, setTitle] = useState('');
  const [userOnlineStatus, setUserOnlineStatus] = useState('offline');
  const { currentUser, trans } = useContext(ConnectContext);
  const { roomDetail, chatItemClick, coverUrl } = props;

  const isOldChat = roomDetail.data !== '';

  const _handleClick = () => {
    chatItemClick(roomDetail);
  };

  const buyer = roomDetail.inviter.userId === currentUser.userId;
  let lastMessage = '';
  let lastMessageTime = '';
  if (roomDetail.lastMessage !== null) {
    lastMessage = formatLastMessage(roomDetail.lastMessage);

    lastMessageTime = displayDate(roomDetail.lastMessage.createdAt);
    if (lastMessageTime === 'Today' || lastMessageTime === 'Yesterday') {
      lastMessageTime = trans[lastMessageTime];
    }
  }

  const _findWhosOnline = () => {
    roomDetail.refresh((response, error) => {
      if (error === null) {
        Object.keys(response.members).forEach(k => {
          const member = response.members[k];
          if (member.userId !== currentUser.userId) {
            if (buyer) {
              setUserOnlineStatus(member.connectionStatus);
            } else if (roomDetail.inviter.userId === member.userId) {
              setUserOnlineStatus(member.connectionStatus);
            }
          }
        });
      }
    });
  };

  const _refreshOnlineStatus = () => {
    setInterval(() => {
      _findWhosOnline();
    }, 10000);
  };

  useEffect(() => {
    _findWhosOnline();
    _refreshOnlineStatus();
    if (isOldChat) {
      try {
        const roomInfo = JSON.parse(roomDetail.data);
        setTitle(roomInfo.title.en);
      } catch (_) {
        setTitle(roomDetail.name);
      }
    } else {
      setTitle(roomDetail.name);
    }
  }, [roomDetail.data, isOldChat]);

  // let chatInviter = '';
  // Object.keys(roomDetail.members).forEach(k => {
  //   if (roomDetail.members[k].userId === roomDetail.inviter.userId) {
  //     chatInviter = roomDetail.members[k];
  //   }
  // });

  const chatRoomCoverUrl = coverUrl;
  const chatRoomInfoUser = title;
  return (
    <div
      className="chat-room-item"
      onClick={_handleClick}
      onKeyDown={_handleClick}
      role="button"
      tabIndex="0"
    >
      <ChatUserAvatar coverUrl={chatRoomCoverUrl} onlineStatus={userOnlineStatus} trans={trans} />
      <div className="chat-room-info">
        <div className="chat-room-info-user">{chatRoomInfoUser}</div>
        <div className="chat-room-last-message">{lastMessage}</div>
      </div>
      <div className="last-message-time">{lastMessageTime}</div>
      {roomDetail.unreadMessageCount !== 0 ? (
        <div className="unread-message">{roomDetail.unreadMessageCount}</div>
      ) : null}
    </div>
  );
};

ChatConnectRoomItem.propTypes = {
  roomDetail: PropTypes.shape().isRequired,
  chatItemClick: PropTypes.func.isRequired,
  coverUrl: PropTypes.string.isRequired,
};

export default ChatConnectRoomItem;
